 
import { useSetAtom } from 'jotai';
import { loadingCounterAtom } from '../Atoms';

export default function CounterManager() {
  const setLoadingCounter = useSetAtom(loadingCounterAtom);
  if (typeof CounterManager.counter === 'undefined') {
    // It has not... perform the initialization
    CounterManager.counter = 0;
  }
  return {
    increment: () => {
      CounterManager.counter += 1;
      //console.log(`increment: ${CounterManager.counter}`);
      setLoadingCounter(CounterManager.counter);
    },
    decrement: () => {
      CounterManager.counter -= 1;
      //console.log(`decrement: ${CounterManager.counter}`);
      setLoadingCounter(CounterManager.counter);
    },
  };
}
